import { FC, useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import { Capacitor } from '@capacitor/core';
import { UpdateProfileData } from 'components/Auth';
import { CardBanner } from 'components/Home';
import { ArrowBackButton } from 'components/shared';
import Stepper from 'components/shared/Stepper';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { ROUTER_URL, STORAGE_KEY } from 'utils/enums';
import { useAndroidBackButton } from 'utils/hooks/use-close-on-back-button';
import { FirebaseAnalytics, StorageService } from 'utils/services';
import styles from './index.module.scss';

enum PROFILE_UPDATE_STEPS {
	PROFILE_DATA,
	CARD_BANNER,
	//APARTMENT_VARIANT,
	//ADD_APARTMENT,
}

//const STEPS = ['Особиcті дані', 'Адреса'];
const STEPS = ['Особиcті дані', 'Картка'];

export const AuthProfileUpdatePage: FC = () => {
	const history = useHistory();
	const platform = Capacitor.getPlatform();
	const isWeb = platform === 'web';

	const [step, setStep] = useState(PROFILE_UPDATE_STEPS.PROFILE_DATA);

	const handleClickCardBanner = useCallback(() => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.CREATE_CARD_BANNER,
			FIREBASE_EVENT_ANALYTICS_BUTTON.CREATE_CARD_RADABANK
		);

		history.push({
			pathname: ROUTER_URL.RADABANK_CARD_AUTH_INFO_BEGIN,
			state: { isFromCard: true },
		});
	}, [history]);

	const handleClickSkip = useCallback(async () => {
		FirebaseAnalytics.logEvent(FIREBASE_EVENT_ANALYTICS_PAGE.AUTH.UPDATE_PROFILE, FIREBASE_EVENT_ANALYTICS_BUTTON.SKIP);
		await StorageService.set(STORAGE_KEY.IS_WAS_LOGGED_IN, true);
		history.push(ROUTER_URL.PROFILE);
	}, [history]);

	//const [apartmentVariant, setApartmentVariant] = useState<null | ADD_APARTMENT_VARIANT>(null);
	//const isApartmentListStep = useAppSelector(getIsPossibleApartmentsStepSelector);

	// const content: JSX.Element = useMemo(() => {
	// 	switch (step) {
	// 		case PROFILE_UPDATE_STEPS.APARTMENT_VARIANT:
	// 			return (
	// 				<UserAppartmentVariant
	// 					onChange={(value: ADD_APARTMENT_VARIANT) => {
	// 						setApartmentVariant(value);
	// 						setStep(PROFILE_UPDATE_STEPS.ADD_APARTMENT);
	// 					}}
	// 					value={apartmentVariant}
	// 					pageName={FIREBASE_EVENT_ANALYTICS_PAGE.AUTH.UPDATE_PROFILE}
	// 				/>
	// 			);

	// 		case PROFILE_UPDATE_STEPS.ADD_APARTMENT:
	// 			return <AuthAddApartment variant={apartmentVariant} />;

	// 		default:
	// 			return (
	// 				<UpdateProfileData
	// 					onSubmit={() => {
	// 						setApartmentVariant(ADD_APARTMENT_VARIANT.ADDRESS);
	// 						setStep(PROFILE_UPDATE_STEPS.ADD_APARTMENT);
	// 					}}
	// 				/>
	// 			);
	// 	}
	// }, [step, apartmentVariant]);

	const content: JSX.Element = useMemo(() => {
		switch (step) {
			case PROFILE_UPDATE_STEPS.CARD_BANNER:
				return <CardBanner onClick={handleClickCardBanner} isActionsDisabled={isWeb} onSkip={handleClickSkip} />;

			default:
				return (
					<UpdateProfileData
						onSubmit={() => {
							setStep(PROFILE_UPDATE_STEPS.CARD_BANNER);
						}}
					/>
				);
		}
	}, [step]);

	// const handleClickBack = useCallback(() => {
	// 	FirebaseAnalytics.logEvent(
	// 		FIREBASE_EVENT_ANALYTICS_PAGE.AUTH.UPDATE_PROFILE,
	// 		FIREBASE_EVENT_ANALYTICS_BUTTON.GO_BACK
	// 	);
	// 	setStep(PROFILE_UPDATE_STEPS.PROFILE_DATA);
	// }, [step]);

	const handleClickBack = useCallback(() => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.AUTH.UPDATE_PROFILE,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_BACK
		);
		setStep(PROFILE_UPDATE_STEPS.PROFILE_DATA);
	}, []);

	useAndroidBackButton(handleClickBack, step);

	return (
		<>
			<div className={styles.header}>
				{step !== PROFILE_UPDATE_STEPS.PROFILE_DATA && <ArrowBackButton onClick={handleClickBack} />}
				<Stepper className={styles.stepper} steps={STEPS} activeStep={step} />
			</div>
			{content}
		</>
	);
};
